// extracted by mini-css-extract-plugin
module.exports = {"modal":"PatientDocumentInfo_modal__g9s3d"};